<template>
  <q-header
    class="h-64 !fixed inset-0 bg-200 py-8 ml-[var(--Nv0-sidebar-width)]"
  >
    <div
      class="w-full flex items-center flex-nowrap gap-8 !px-20 container-base"
    >
      <p class="text-neutral-100 text-headline-2">
        {{ t('welcomeBack') }}
        <span class="text-primary-admin !font-bold capitalize">
          {{ nome }}
        </span>
      </p>

      <div class="flex-1" />

      <OButton
        v-show="false"
        secondary
        size="md"
        class="!size-48 !p-0 shadow-sm"
        @click="isNotifOpen = !isNotifOpen"
      >
        <IconNotification class="!size-24 text-black" />
        <DropdownNotification v-model="isNotifOpen" />
      </OButton>

      <OButton class="!p-4 !h-48 shadow-sm" secondary size="md">
        <q-avatar
          color="primary-admin/10"
          text-color="primary-admin"
          size="34px"
          rounded
        >
          <p class="text-headline-3">
            {{ iniciais }}
          </p>
        </q-avatar>
        <q-icon name="keyboard_arrow_down" />
        <HeaderMenuUser :user :show-languages="true" />
      </OButton>
    </div>
  </q-header>
</template>

<script setup>
import { computed, inject, ref } from 'vue'
import { useI18n } from 'vue-i18n'

import DropdownNotification from 'components/Admin/Notifications/DropdownNotification.vue'
import HeaderMenuUser from 'components/Header/HeaderMenuUser.vue'
import IconNotification from 'public/icons/notification.svg'
import OButton from 'components/Button/OButton.vue'

const { t } = useI18n()

const context = inject('context')

const isNotifOpen = ref(false)
const user = ref(context?.user)

const nome = computed(
  () =>
    user.value?.nome || user.value?.first_name || user.value?.username
)

const iniciais = computed(() => {
  if (user.value?.first_name && user.value?.last_name) {
    return (
      user.value?.first_name.charAt(0).toUpperCase() +
      user.value?.last_name.charAt(0).toUpperCase()
    )
  }
  if (user.value?.first_name) {
    return user.value?.first_name.slice(0, 2).toUpperCase()
  }
  return user.value?.username.slice(0, 2).toUpperCase()
})
</script>

<style lang="scss" scoped></style>
